import { createAction, props } from "@ngrx/store";
import IUserSkill from "@skills-app/models/userSkills";
import { ISkillNode } from "@skills-app/models/skillNode";
import IOrgNode from "@skills-app/models/orgNode";

const prefix = "[Search By Skill Or Consultant Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const unloadPage = createAction(`${prefix} Unload Page`);

export const filterConsultantsByRole = createAction(
  `${prefix} Filter Consultants By Role`,
  props<{ roles: string[] }>(),
);

export const filterConsultantsByOrg = createAction(
  `${prefix} Filter Consultants By Org`,
  props<{ orgs: IOrgNode[] }>(),
);

export const lobSelectionReadyForSearch = createAction(
  `${prefix} LOB Selection Ready For Search`,
);

export const filterConsultantsByLocation = createAction(
  `${prefix} Filter Consultants By Location`,
  props<{ locations: string[] }>(),
);

export const showUnknownProficiency = createAction(
  `${prefix} Show Unknown Proficiency`,
);

export const showRelatedSkills = createAction(`${prefix} Show Related Skills`);

export const resetShowRelatedSkills = createAction(
  `${prefix} Reset Show Related Skills`,
);

export const showExpiredCerts = createAction(`${prefix} Show Expired Skills`);

export const setUpdatedWithinMonths = createAction(
  `${prefix} Set Updated Within Months`,
  props<{ months: number | null }>(),
);

export const toggleHideNoProfile = createAction(
  `${prefix} Toggle Hide No Profile`,
);

export const setHideNoProfile = createAction(
  `${prefix} Set Hide No Profile`,
  props<{ hide: boolean }>(),
);

export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skillId: string }>(),
);

export const selectSkillObject = createAction(
  `${prefix} Select Skill Object`,
  props<{ skill: ISkillNode }>(),
);

export const addToTeam = createAction(
  `${prefix} Add To Team`,
  props<{ userSkills: IUserSkill[] }>(),
);

export const removeFromTeam = createAction(
  `${prefix} Remove From Team`,
  props<{ userSkill: IUserSkill }>(),
);

export const downloadProfile = createAction(
  `${prefix} Download Profile`,
  props<{ fileName: string; email: string; templateType: string }>(),
);

export const downloadProfileSuccess = createAction(
  `${prefix} Download Profile Success`,
);

export const downloadProfileError = createAction(
  `${prefix} Download Profile Error`,
);

export const clearSelectedRoles = createAction(
  `${prefix} Clear Selected Roles`,
);
